/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/PhonelinkLock';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PhonelinkLockIcon = withMuiAdapter(Base, 'PhonelinkLock');
